import { BlockerFunction, useBlocker } from "react-router-dom";
import React from "react";

/**
 * Prompt
 * @description A window prompt that will be triggered when the user tries to navigate away from the page
 * @constructor
 * @param {boolean} when
 * @param {string} message
 */
const usePrompt = (when: boolean, message: any): any  => {

    const shouldBlock = React.useCallback<BlockerFunction>(
        ({ currentLocation, nextLocation }) =>
            when && currentLocation.pathname !== nextLocation.pathname ? !window.confirm(message) : false,
        [when]
    );
    const blocker = useBlocker(shouldBlock);

    // Reset the blocker if the user cleans the form
    React.useEffect(() => {
        if (blocker.state === "blocked" && !when) {
            blocker.reset();
        }
    }, [blocker, when]);
}

export const Prompt = ({ when, message }: { when: boolean, message: string }) => {
    usePrompt(when, message);
    return null;
}